import { useAppState } from "./use-app-state";

export function useDisclosure(initialValue = { open: false, data: null }) {
  const [state, setState] = useAppState(initialValue);

  const onOpen = (data = {}) => {
    setState({ open: true, data });
  };
  const onClose = () => {
    setState({ open: false });
  };
  const toogle = () => {
    setState({ open: !state.open });
  };

  return [state, { open: onOpen, close: onClose, toogle }];
}
